import type { BookingSharedMessages } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

export const genericMessagesFallback: BookingSharedMessages = {
  internalName: '',
  genericErrorMessage: '',
  clipboardCopySuccessMessage: '',
  clipboardCopyFailureMessage: ''
}
